import React, { useContext } from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';

import BouncedEmailsContext from '@totem/components/administration/bouncedEmails/BouncedEmailsContext';
import BouncedEmailsTable from '@totem/components/administration/bouncedEmails/BouncedEmailsTable';
import FiltersChipsContainer from '@totem/components/ui_components/filters/FilterChipsContainer';
import FilterChips from '@totem/components/ui_components/reportSettings/filterChips';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

export const BouncedEmailsExtra = () => {
  const { totalRecords, onRefresh } = useContext(BouncedEmailsContext);

  return (
    <Space>
      <RecordCountBadge count={totalRecords} />
      <Tooltip title="Refresh">
        <Button icon={<ReloadOutlined />} onClick={onRefresh} />
      </Tooltip>
    </Space>
  );
};

export const BouncedEmailsLayout = () => (
  <>
    <FiltersChipsContainer>
      <FilterChips />
    </FiltersChipsContainer>
    <BouncedEmailsTable />
  </>
);

export default BouncedEmailsLayout;
